<template>
  <div class="partner-directory mt-2">
    <CRow>
      <CCol md="3">
        <DirectoryFilter @filterAction="filterAction" />
      </CCol>
      <CCol md="9">
        <DirectoryList :filterData="filterValue" />
      </CCol>
    </CRow>
  </div>
</template>
<script>
import DirectoryFilter from "../../containers/TFW/PartnerDirectory/DirectoryFilter.vue";
import DirectoryList from "../../containers/TFW/PartnerDirectory/DirectoryList.vue";

export default {
  name: "PartnerDirectory",
  components: {
    DirectoryFilter,
    DirectoryList,
  },
  data() {
    return {
      filterValue: {},
    };
  },
  methods: {
    filterAction(value) {
      this.filterValue = value;
    },
  },
};
</script>
<style lang="scss" scoped></style>
